import { NpsMutations, NpsState } from './types';
import { MutationTree } from 'vuex';
import { INps } from '@mentessa/types';

export const mutations: MutationTree<NpsState> = {
  [NpsMutations.SetNps](state: NpsState, nps: INps) {
    state.nps = nps;
  },
};
